export const imageType = [
    'grilla_estatica',
    'grilla_dinamica'
]

export const geoJsonType = [
    'bubble',
    'bar',
    'poligono',
    'conectividad_estatica',
    'conectividad_dinamica',
    'geojson'
];

export const fillGraph = [
    'bar',
    'geojson'
];

export const allGraphs = [
    'grilla_estatica',
    'grilla_dinamica',
    'bubble',
    'bar',
    'donut',
    'poligono',
    'conectividad_estatica',
    'conectividad_dinamica',
    'barra_3d',
    'conectividad_estatica_3d',
    'conectividad_dinamica_3d',
    'polygon_max_tvd',
    'level',
    'graphs',
    'intake_tvd',
    'max_tvd',
    'geojson',
    'intake_tvd'
  ]

export const model3dType = [
    'barra_3d', 'conectividad_estatica_3d', 'conectividad_dinamica_3d'
];